import {
  DELETE_FILTER_BODY_COLORS,
  SET_FILTER_BODY_COLORS,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

import { RESET_FILTER_BODY_COLORS } from '../../../../../actions/pages/pcp/filters/bodyColors/index';

export interface BodyColorsStateProps {
  colors: string[];
  filterCount: number;
}

export const InitialBodyColorsState: BodyColorsStateProps = {
  colors: [],
  filterCount: 0,
};

const BodyColorsState = (
  state: BodyColorsStateProps = InitialBodyColorsState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_BODY_COLORS:
      return {
        ...state,
        colors: action.payload?.colors,
        filterCount: (action.payload?.colors || []).length,
      };
    case DELETE_FILTER_BODY_COLORS: {
      const index = state.colors.indexOf(action.payload?.color);
      const colors = [
        ...state.colors.slice(0, index),
        ...state.colors.slice(index + 1),
      ];

      return {
        ...state,
        colors,
        filterCount: state.filterCount - 1,
      };
    }
    case RESET_FILTER_BODY_COLORS:
      return InitialBodyColorsState;
    default:
      return state;
  }
};

export default BodyColorsState;
